export const LOCALSTORAGE_UI_SETTINGS_KEY = 'BENTO_UI_SETTINGS';
